import { InternalApiRequest } from '@app/services/api-request/';

export abstract class ApiCollection {
  constructor(protected apiService = InternalApiRequest) {}
}
